module.exports = __webpack_public_path__ + "static/media/logo-gertner-vertikalni.b86559ae.svg";